import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTextAreaComponent } from './custom-text-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    CustomTextAreaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    
  ],
  exports:[CustomTextAreaComponent]
})
export class CustomTextAreaModule { }
